import 'css/src/global';

import React from 'react';

import DashboardTrim from 'js/src/components/common/DashboardTrim';
import FeatureLockModal from 'js/src/components/common/ui/feature-lock-modal';
import ShareVideo from 'js/src/components/share-video/share-video';
import {
    getLuminaryResolutionFromAvailScreenWidth,
    LuminaryResolutionPreset,
} from 'js/src/libs/video-data-consts';
import { LUMINARY_VIDEO_STORE_NAME, LuminaryContextProvider } from 'js/src/luminary';

const ShareVideoPage = React.memo(function ShareVideoPage() {
    return (
        <LuminaryContextProvider
            minDimensionResolution={getLuminaryResolutionFromAvailScreenWidth(
                LuminaryResolutionPreset.HIGH,
            )}
            drawsToCanvas={true}
            name={LUMINARY_VIDEO_STORE_NAME}
        >
            <DashboardTrim sidebar="none">
                <ShareVideo />
            </DashboardTrim>
            <FeatureLockModal key="feature_lock_modal" />
        </LuminaryContextProvider>
    );
});

export default ShareVideoPage;
